import React from "react";
import CommonTimeSheetTable from "../../common/Timesheet/TimesheetTable";

/**
 * MilestoneLogs - Timesheet table embedded inside MilestoneDetail page.
 * Uses the SAME CommonTimeSheetTable component used in Timesheet page (image 2).
 *
 * - overrideProjectId ΓåÆ project_id from route (since `id` in this page = milestone_id)
 * - filterByMilestoneName ΓåÆ auto-filter logs for this specific milestone only
 *
 * Guard: Don't mount the table until milestoneName is known.
 * This prevents a race-condition where the API fires with view_type=6 (My logs only)
 * before the milestone name arrives, causing Managers to see unfiltered data.
 */
const MilestoneLogs = ({ milestoneName, projectId, milestoneId }) => {
  // Wait until milestone name is resolved before mounting the table.
  // This ensures filterByMilestoneName is always set on first API call,
  // so the correct view_type=1 is used and the milestone filter is applied.
  if (!milestoneName) {
    return null; // or a small spinner if you prefer
  }

  return (
    <CommonTimeSheetTable
      showPath="task/timelog"
      updatePath="task/timelog"
      isModule={false}
      isProject={true}
      overrideProjectId={projectId}
      filterByMilestoneName={milestoneName}
      filterByMilestoneId={milestoneId}
    />
  );
};

export default MilestoneLogs;
